import React, {Fragment, type PropsWithChildren} from 'react';
import type {SxProps} from '@mui/material';
import {Box, useTheme} from '@mui/material';
import type {IconName} from 'components/icons/types';
import {Card, FlexBox, Icon, IconButton} from 'components';

type Props = PropsWithChildren & {
  title: string;
  icon: IconName;
  onClose: () => void;
  extraButtons?: React.ReactNode[];
};

const headerSx: SxProps = {
  justifyContent: 'space-between',
};
export const ManifestationPanelContainer: React.FC<Props> = ({
  title,
  icon,
  onClose,
  extraButtons,
  children,
}) => {
  const {colors} = useTheme();
  return (
    <Card colorx={colors.beige} fillHeight>
      <Card.Header sx={headerSx}>
        <Box>
          {title || icon ? (
            <FlexBox center left horizontal gap={0.5}>
              {icon ? <Icon icon={icon} /> : null}
              {title ? <Box>{title}</Box> : null}
            </FlexBox>
          ) : null}
        </Box>
        <Box>
          {extraButtons?.map((eB, i) => (
            <Fragment key={i}>{eB}</Fragment>
          ))}

          <IconButton icon={'Close'} onClick={onClose} size={'small'} />
        </Box>
      </Card.Header>
      <Card.Content>{children}</Card.Content>
    </Card>
  );
};
